import {
  Avatar,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Pagination,
  PaginationProps,
  TimePicker,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { ActivityService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../common/components/simpleInput";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import style from "./style.module.scss";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  generateColorArray,
  getNumberOfALetter,
} from "../../../../utilities/random_color";
import { getFirstCharOfAstring } from "../../../../utilities/string";
import { IoMdAdd } from "react-icons/io";
import CustomModal from "../../../../common/components/Modal/CustomModal";
import { Loader } from "../../../../common/components/Loader/Loader";
import { SearhcInput } from "../../../../common/components/searchInput/SearhcInput";
import { getAllStaff } from "../../../employess/staff/core/_request";
import { useQueryStaffPostForSelect } from "../../../../common/hooks/StaffPost";
import { ModelList } from "../saleOperations/planning/ModelList";

dayjs.extend(utc);

const COLORS = generateColorArray(50);

const INITIAL_PAGINATION = {
  page: 1,
  itemsPerPage: 10,
};

type ActivityFormType = {
  onFinish: () => void;
  initialValue?: any;
};

const showTotal: PaginationProps["showTotal"] = (total: number) =>
  `Total ${total}`;

export const ActivityForm = ({ onFinish, initialValue }: ActivityFormType) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isOpenModalUser, setIsOpenModalUser] = useState<boolean>(false);

  const [initialState, setInitialState] = useState<any>({});
  const [selectedStaff, setSelectedStaff] = useState<Array<any>>([]);
  const [isLoadingStaff, setIsLoadingStaff] = useState<boolean>(false);
  const [staffs, setStaffs] = useState<Array<any>>([]);
  const [staffsTotal, setStaffsTotal] = useState<number>(0);
  const [paginationsStaff, setPaginationStaff] = useState(INITIAL_PAGINATION);

  const [isOpenModalTeam, setIsOpenModalTeam] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpenModalUser) {
      setPaginationStaff(INITIAL_PAGINATION);
    }
  }, [isOpenModalUser]);

  useEffect(() => {
    getAllStaffsForList({ ...paginationsStaff });
  }, [paginationsStaff]);

  const getAllStaffsForList = async (params: any) => {
    try {
      setIsLoadingStaff(true);
      const res = await getAllStaff({
        ...paginationsStaff,
        departmentType: "EXPLOITATION",
        ...params,
      });
      if (res?.status === HttpStatusCode.Ok) {
        if (Array.isArray(res?.data?.member)) {
          setStaffs(res?.data?.member);
          setStaffsTotal(res?.data?.totalItems);
        } else {
          setStaffs([]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingStaff(false);
    }
  };

  const handleIsOpenModalUser = () => {
    setIsOpenModalUser((prev: boolean) => !prev);
  };

  const onCancelStaffSelection = () => {
    setSelectedStaff(initialState?.staff || []);
    setIsOpenModalUser(false);
  };

  const onCloseUserModal = () => {
    setIsOpenModalUser(false);
  };

  const handleIsOpenModalTeam = () => {
    setIsOpenModalTeam((prev: boolean) => !prev);
  };

  const handleClickOnStaffPost = (/* value: any */) => {
    /* setSelectedStaffPost(value);
    setSelectedStaff(value?.staff); */
    handleIsOpenModalUser();
  };

  const staffList = initialState?.staff || [];

  const handleCheckUser = (staff: any) => {
    const exists = selectedStaff.some(
      (item) => item?.["@id"] === staff?.["@id"]
    );
    if (exists) {
      setSelectedStaff((prev) =>
        prev.filter((item) => item?.["@id"] !== staff?.["@id"])
      );
    } else {
      setSelectedStaff((prev) => [...prev, staff]);
    }
  };

  const onClicOnValidateStaff = () => {
    setInitialState((prev: any) => ({
      ...prev,
      staff: selectedStaff,
    }));
    onCloseUserModal();
  };

  useEffect(() => {
    if (initialValue) {
      const start = dayjs
        .utc(initialValue.startDate, "DD/MM/YYYY HH:mm:ss")
        .local();
      const end = dayjs
        .utc(initialValue.endDate, "DD/MM/YYYY HH:mm:ss")
        .local();

      form.setFieldsValue({
        ...initialValue,
        startDate: start,
        startTime: start,
        endDate: end,
        endTime: end,
      });

      const existingStaff = initialValue?.staff || [];
      setInitialState({ staff: existingStaff });
      setSelectedStaff(existingStaff);
    }
  }, [initialValue]);

  {
    /*FUNCTION RELATED TO THE TEAM MODAL */
  }
  const handleModelConfirm = (modelTeam: any) => {
    const extractedStaffs =
      modelTeam?.modelTeamStaff?.flatMap((m: any) => m.staff) || [];

    setInitialState((prev: any) => {
      const existingIds = prev?.staff?.map((s: any) => s["@id"]) || [];

      // Ajouter les nouveaux sans doublon
      const uniqueStaff = extractedStaffs.filter(
        (s: any) => !existingIds.includes(s["@id"])
      );

      const updatedStaffList = [...(prev?.staff || []), ...uniqueStaff];

      return {
        ...prev,
        staff: updatedStaffList,
      };
    });

    setSelectedStaff((prev: any) => {
      const existingIds = prev.map((s: any) => s["@id"]);
      const uniqueNewStaff = extractedStaffs.filter(
        (s: any) => !existingIds.includes(s["@id"])
      );
      return [...prev, ...uniqueNewStaff];
    });

    handleIsOpenModalTeam();
  };

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      const startDateTime = dayjs(
        `${values.startDate.format("YYYY-MM-DD")}T${values.startTime.format(
          "HH:mm"
        )}`
      ).toISOString();

      const endDateTime = dayjs(
        `${values.endDate.format("YYYY-MM-DD")}T${values.endTime.format(
          "HH:mm"
        )}`
      ).toISOString();

      const staffIds = initialState?.staff?.map((s: any) => s["@id"]);

      const dataToPost = {
        task: values.task,
        staff: staffIds,
        startDate: startDateTime,
        endDate: endDateTime,
        ...(initialValue
          ? {
              id: parseInt(initialValue?.["@id"].split("/").pop(), 10),
            }
          : {}),
      };

      const res = initialValue
        ? await ActivityService.updateActivity(dataToPost)
        : await ActivityService.createActivity(dataToPost);

      if (
        res?.status === HttpStatusCode.Ok ||
        res?.status === HttpStatusCode.Created
      ) {
        onFinish();
        form?.resetFields();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Date de début"
                name={"startDate"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<DatePicker showNow={false} />}
              />
            </div>
            <div className={`${style.form__item}`}>
              <SimpleInput
                Form={Form}
                label="Heure de début"
                name={"startTime"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <TimePicker
                    needConfirm={false}
                    format={"HH:mm"}
                    showNow={false}
                  />
                }
              />
            </div>
          </div>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Date de fin"
                name={"endDate"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<DatePicker showNow={false} />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Heure de fin"
                name={"endTime"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <TimePicker
                    needConfirm={false}
                    format={"HH:mm"}
                    showNow={false}
                  />
                }
              />
            </div>
          </div>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Tâches"
                name={"task"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            {/* ÉQUIPE */}
            <div className={style.form__item}>
              <span className={style.form__team_text}>Équipe</span>
              <div className={style.team__items}>
                <div className="team_form__team_item">
                  <Avatar.Group>
                    {staffList.map((staffItem: any, index: number) => (
                      <Tooltip
                        title={staffItem.fullname}
                        key={index}
                        placement="top"
                      >
                        <Avatar
                          style={{
                            backgroundColor:
                              COLORS[
                                getNumberOfALetter(
                                  getFirstCharOfAstring(staffItem.fullname)
                                )
                              ],
                          }}
                        >
                          {getFirstCharOfAstring(staffItem.fullname)}
                        </Avatar>
                      </Tooltip>
                    ))}

                    {/* Avatar + pour ajouter */}
                    <Avatar
                      style={{
                        backgroundColor: "white",
                        border: "2px solid rgb(208, 206, 206)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        handleClickOnStaffPost();
                      }}
                    >
                      <IoMdAdd
                        style={{ color: "rgb(208, 206, 206)", fontSize: 18 }}
                      />
                    </Avatar>
                  </Avatar.Group>
                </div>
                <span
                  /* className={style.team_form_button}  */ className="team_form__link"
                  onClick={() => {
                    setIsOpenModalTeam(true);
                  }}
                >
                  Utiliser un model existant{" "}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>

      {isOpenModalUser && (
        <CustomModal
          isOpen={isOpenModalUser}
          hanldeCloseModal={handleIsOpenModalUser}
          title={"Ajouter des membres à l'équipe"}
          width={800}
        >
          <Loader isLoading={isLoadingStaff} />
          <SearhcInput
            onSearch={(e) => {
              setPaginationStaff((prev) => ({ ...prev, page: 1, fullname: e }));
            }}
          />
          <table className="team_form__team_table">
            <thead>
              <tr>
                <th className="team_form__team_table_th"> Nom(s) </th>
              </tr>
            </thead>
            <tbody>
              {staffs?.map((item: any, key: number) => (
                <tr key={key}>
                  <td className="team_form__team_table_td">
                    <Checkbox
                      checked={selectedStaff.some(
                        (s) => s?.["@id"] === item?.["@id"]
                      )}
                      onChange={() => handleCheckUser(item)}
                    >
                      <span>{item?.fullname}</span>
                    </Checkbox>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-4 d-flex w-100 justify-content-end">
            <Pagination
              className="w-full"
              simple
              showSizeChanger
              showTotal={showTotal}
              defaultCurrent={1}
              current={paginationsStaff?.page}
              pageSize={paginationsStaff?.itemsPerPage || 10}
              total={staffsTotal || 0}
              onChange={(page, itemsPerPage) => {
                setPaginationStaff({
                  page: page ?? 1,
                  itemsPerPage,
                });
              }}
            />
          </div>

          <div className="team_form__footer_wrapper mt-4">
            <button
              className="team_form__button_secondary"
              onClick={onCancelStaffSelection}
            >
              Annuler
            </button>

            <button
              className="team_form__button_primary"
              onClick={onClicOnValidateStaff}
            >
              Valider{" "}
            </button>
          </div>
        </CustomModal>
      )}
      {isOpenModalTeam && (
        <>
          <CustomModal
            isOpen={isOpenModalTeam}
            hanldeCloseModal={handleIsOpenModalTeam}
            title={"Choisir une équipe"}
            width={800}
          >
            <Loader isLoading={isLoadingStaff} />
            <ModelList onConfirm={handleModelConfirm} />
          </CustomModal>
        </>
      )}
    </div>
  );
};
